import { isNullOrUndefined, getEnumValue } from '@syncfusion/ej2-base';
import { RenderType } from '../base/enum';
/**
 * RendererFactory
 *
 * @hidden
 * @deprecated
 */
export class RendererFactory {
    constructor() {
        this.rendererMap = {};
    }
    /**
     * addRenderer method
     *
     * @param {RenderType} name - specifies the render type
     * @param {IRenderer} type - specifies the renderer.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    addRenderer(name, type) {
        const rName = getEnumValue(RenderType, name);
        if (isNullOrUndefined(this.rendererMap[`${rName}`])) {
            this.rendererMap[`${rName}`] = type;
        }
    }
    /**
     * getRenderer method
     *
     * @param {RenderType} name - specifies the render type
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getRenderer(name) {
        const rName = getEnumValue(RenderType, name);
        if (isNullOrUndefined(this.rendererMap[`${rName}`])) {
            // eslint-disable-next-line
            throw `The renderer ${rName} is not found`;
        }
        else {
            return this.rendererMap[`${rName}`];
        }
    }
    destroy() {
        this.rendererMap = {};
    }
}
